import { TNodeProps } from '../types/node';
import { BaseNode } from './BaseNode';
import { StandardHandles } from './StandardHandles';

export const ApiCallNode = (props: TNodeProps) => {
  return (
    <BaseNode {...props} className="min-w-80">
      <StandardHandles withReverseVerticals />
    </BaseNode>
  );
};
